import { requestByGET, requestByPOST, requestByPATCH } from 'lib/requests'
import { buildPathParams } from 'lib/utils/url'
import {
  buildCreateUserRequest,
  buildUpdateUserRequest,
  buildChangePasswordRequest,
  mapCreditCard,
} from './mappers'

const OPTIONS = {
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  timeout: 30000,
  withCredentials: true,
}

const END_POINTS = {
  USERS: '/users',
  CREDIT_CARD: '/v2/user/credit-card/{market}',
}

interface CreateUserDto {
  data: {
    email: string
    password: string
    market: string
    language: string
  }
  hostname: string
}

interface CreateUserDtoResponseSuccess {
  data: {
    email: string
    firstName: string
    id: number
    lastName: string
    phone: string
  }
  status: 201
}

interface CreateUserDtoResponseError {
  data: {
    errorCode: string
  }
  status: number
}

export type CreateUserDtoResponse = CreateUserDtoResponseSuccess | CreateUserDtoResponseError

interface UpdateUserDto {
  data: {
    firstName: string
    lastName: string
    phone: string
  }
  hostname: string
}

interface UpdateUserDtoResponseSuccess {
  data: ''
  status: 200
}

interface UpdateUserDtoResponseError {
  data: {
    errorCode: string
  }
  status: number
}

export type UpdateUserDtoResponse = UpdateUserDtoResponseSuccess | UpdateUserDtoResponseError

interface ChangePasswordDto {
  data: {
    currentPassword: string
    newPassword: string
  }
  hostname: string
}

interface ChangePasswordResponseSuccess {
  data: ''
  status: 200
}

interface ChangePasswordResponseError {
  data: {
    errorCode: string
  }
  status: number
}

export type ChangePasswordResponse = ChangePasswordResponseSuccess | ChangePasswordResponseError

interface FetchCustomerCreditCardDto {
  hostname: string
  market: string
}

interface FetchCustomerCreditCardSuccess {
  data: {
    brand: string
    expiryDate: string
    holder: string
    number: string
  }
  status: 200
}

interface FetchCustomerCreditCardError {
  data: {
    errorCode: string
  }
  status: number
}

export type FetchCustomerCreditCardResponse =
  | FetchCustomerCreditCardSuccess
  | FetchCustomerCreditCardError

export function createUser(params: CreateUserDto): Promise<CreateUserDtoResponse> {
  return requestByPOST({
    data: buildCreateUserRequest(params.data),
    endpoint: END_POINTS.USERS,
    hostname: params.hostname,
    options: OPTIONS,
  })
}

export function updateUser(params: UpdateUserDto): Promise<UpdateUserDtoResponse> {
  return requestByPATCH({
    data: buildUpdateUserRequest(params.data),
    endpoint: END_POINTS.USERS,
    hostname: params.hostname,
    options: OPTIONS,
  })
}

export function changePassword(params: ChangePasswordDto) {
  return requestByPATCH({
    data: buildChangePasswordRequest(params.data),
    endpoint: END_POINTS.USERS,
    hostname: params.hostname,
    options: OPTIONS,
  })
}

export function fetchCustomerCreditCard(
  params: FetchCustomerCreditCardDto
): Promise<FetchCustomerCreditCardResponse> {
  return requestByGET({
    data: null,
    endpoint: buildPathParams(END_POINTS.CREDIT_CARD, params),
    hostname: params.hostname,
    mapper: mapCreditCard,
    options: OPTIONS,
  })
}
